import {
  DELETE_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_REQUEST,
  DELETE_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_SUCCESS,
  DELETE_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_FAIL,
} from '../actions/deleteTradeAgreementSellOutValidator';

const initialState = {
  loading: false,
};

const deleteTradeAgreementSellOutValidatorReducer = (state = initialState, action) => {
  const { type } = action;
  //const { validators, counter } = state;
  switch (type) {
    case DELETE_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case DELETE_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_SUCCESS:
    case DELETE_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default deleteTradeAgreementSellOutValidatorReducer;
